module.exports = __webpack_public_path__ + "static/media/auction-bid-t3.0c1fe009.nom";